import type { QueryClient, QueryKey } from '@tanstack/vue-query';

export const invalidateQueryKeys = (queryClient: QueryClient, queryKeys: QueryKey[]) => {
    const invalidations: Promise<unknown>[] = [];

    for (const queryKey of queryKeys) {
        invalidations.push(queryClient.invalidateQueries({ queryKey }));
    }

    return Promise.all(invalidations)
        .then(() => undefined)
        .catch(console.error);
};
